import { WorkOrder } from '@/core/domain/workorder/WorkOrders/WorkOrders.types';
import { WorkOrderComplement } from '@/core/domain/workorder/WorkOrdersComplements/WorkOrdersComplements.types';
import { ListWorkOrderItemResult } from '@/core/domain/workorder/WorkOrdersItems/WorkOrdersItems.types';
import formatterPrice from '@/utils/number/formatterPrice';
import { message } from 'antd';
import moment from 'moment';

export const wppTags: Record<string, string> = {
  '{{nomeDoCliente}}': 'Nome do cliente',
  '{{primeiroNomeDoCliente}}': 'Primeiro nome do cliente',
  '{{ultimoNomeDoCliente}}': 'Ultimo nome do cliente',
  '{{modeloDoVeiculo}}': 'Modelo do veículo',
  '{{marcaDoVeiculo}}': 'Marca do veículo',
  '{{placaDoVeiculo}}': 'Placa do veículo',
  '{{nomeDaOficina}}': 'Nome da oficina',
  '{{nomeFantasia}}': 'Nome fantasia da oficina',
  '{{urlDoOrcamento}}': 'URL do orçamento',
  '{{dataDeEntrada}}': 'Data de entrada',
  '{{previsaoDeEntrega}}': 'Data de previsão de entrega',
  '{{valorDoOrcamento}}': 'Valor do orçamento',
  '{{urlDoChecklist}}': 'URL do checklist',
  '{{imagensDoChecklist}}': 'Imagens do checklist',
  '{{urlAssinaturaDaOs}}': 'Url de assinatura da OS',
  '{{numeroOS}}': 'Número da OS',
  '{{boschCoReURL}}': 'URL do Relatório do Diagnóstico CoRe',
};

export const wppDefaultWppText = `Olá *{{nomeDoCliente}}*, tudo bem?
\nAbaixo está o link para acessar o orçamento referente ao veículo: *{{modeloDoVeiculo}} - {{marcaDoVeiculo}}*, placa: *{{placaDoVeiculo}}*, oficina: *{{nomeDaOficina}}*
\n{{urlDoOrcamento}}
\nData de entrada: *{{dataDeEntrada}}*
\nPrevisão de entrega: *{{previsaoDeEntrega}}*
\nValor do orçamento: *{{valorDoOrcamento}}*
`;

type WppTextFormatOptions = {
  wppText?: string;
  complement?: WorkOrderComplement;
  workorder?: WorkOrder;
  workorderItems?: ListWorkOrderItemResult;
  checklistImages?: string[];
  arToken?: string;
  checklistToken?: string;
};

export function wppTextFormat({
  wppText,
  complement,
  workorder,
  workorderItems,
  checklistImages,
  arToken,
  checklistToken,
}: WppTextFormatOptions) {
  if (
    wppText?.includes('{{urlAssinaturaDaOs}}') &&
    !complement?.workOrderGuid
  ) {
    message.error(
      'Não é possível utilizar a tag {{urlAssinaturaDaOs}} porque o orçamento ainda não possui um código público (GUID) gerado.',
      5,
    );
  }

  return (
    wppText
      ?.replaceAll('{{nomeDoCliente}}', workorder?.customer?.name || '-')
      .replaceAll(
        '{{primeiroNomeDoCliente}}',
        workorder?.customer?.name.split(' ')[0] || '-',
      )
      .replaceAll(
        '{{ultimoNomeDoCliente}}',
        workorder?.customer?.name.split(' ').at(-1) || '-',
      )
      .replaceAll('{{modeloDoVeiculo}}', workorder?.vehicle?.model || '-')
      .replaceAll('{{marcaDoVeiculo}}', workorder?.vehicle?.brand || '-')
      .replaceAll('{{placaDoVeiculo}}', workorder?.vehicle?.licensePlate || '-')
      .replaceAll('{{nomeDaOficina}}', workorder?.company?.name || '-')
      .replaceAll('{{nomeFantasia}}', workorder?.company?.nickName || '-')
      .replaceAll(
        '{{dataDeEntrada}}',
        complement?.entryDate
          ? moment(complement.entryDate).format('DD/MM/YYYY')
          : '-',
      )
      .replaceAll(
        '{{previsaoDeEntrega}}',
        complement?.estimatedLeaveDate
          ? moment(complement.estimatedLeaveDate).format('DD/MM/YYYY')
          : '-',
      )
      .replaceAll(
        '{{valorDoOrcamento}}',
        typeof workorderItems?.total === 'number'
          ? formatterPrice(workorderItems?.total)
          : '-',
      )
      .replaceAll(
        '{{urlDoOrcamento}}',
        arToken
          ? `${window.location.origin}/ar/${arToken}`
          : '[URL_DO_RELÁTORIO]',
      )
      .replaceAll(
        '{{urlDoChecklist}}',
        checklistToken
          ? `${window.location.origin}/r/c/checklist?token=${checklistToken}`
          : '[URL_DO_CHECKLIST]',
      )
      .replaceAll(
        '{{imagensDoChecklist}}',
        `${checklistImages?.map((imageCoded) => {
          const image = encodeURI(imageCoded);
          if (image) {
            return `\n🖼 ${image}`;
          }
          return '';
        })}`,
      )
      .replaceAll(
        '{{urlAssinaturaDaOs}}',
        complement?.workOrderGuid
          ? `${window.location.origin}/r/os/${complement.workOrderGuid}`
          : '[CÓDIGO_PÚBLICO_NÃO_DISPONÍVEL]',
      )
      .replaceAll('{{numeroOS}}', `${complement?.complementIdentifier || '-'}`)
      .replaceAll(
        '{{boschCoReURL}}',
        `${process.env.REACT_APP_API_URL}/workorder/v1/Bosch/${complement?.workOrderGuid}/bosch-report-by-guid`,
      ) || ''
  );
}
